import React from "react";
import { Search } from "lucide-react";

interface FileEmptyStateProps {
  searchQuery?: string;
}

const FileEmptyState = ({ searchQuery }: FileEmptyStateProps) => {
  return (
    <div className="text-center py-12">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
        <Search className="h-6 w-6 text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">No files found</h3>
      <p className="text-gray-500">
        {searchQuery
          ? `No files matching "${searchQuery}" found.`
          : "No files in this category yet."}
      </p>
    </div>
  );
};

export default FileEmptyState;
